import React, { useEffect, useState, useRef } from 'react'

import Lottie from 'react-lottie';
import Slider from "react-slick";
import InputMobile from '../../components/InputMobile';
import TextArea from '../../components/TextArea';
import CheckBox from '../../components/CheckBox';

import jsonData from '../../images/json/animatePrimary.json'; // Importe o arquivo JSON
import companyIcon from '../../images/png/companyIcon.jpg'
import contactIcon from '../../images/svg/contactIcon.svg'
import menuIcon from '../../images/png/cardapio.png'
import closeIcon from '../../images/png/close.png'
import { ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import api from '../../services/api';
import { Link } from 'react-router-dom';


const Landing = () => {

    const [name, setName] = useState()
    const [companyName, setCompanyName] = useState()
    const [departament,setDepartament] = useState()
    const [mail, setMail] = useState()
    const [description, setDescription] = useState()

    const [checkPrimary, setCheckPrimary] = useState(false)
    const [checkSecondary, setCheckSecondary] = useState(false)

    const [sidebar, setSidebar] = useState(false)

    const sendMail = async () => {

        if (name == undefined || name == "") {
            return toast.error('Informe um nome', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
        
                progress: undefined,
                theme: "light",
              });
              
        }

        if(companyName == undefined || companyName == ""){
            return toast.error('Informe o nome da empresa', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
        
                progress: undefined,
                theme: "light",
              });
        }

        if(mail == undefined || mail == ""){
            return toast.error('Informe um email', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
        
                progress: undefined,
                theme: "light",
              });
        }

        if(departament == undefined || departament == ""){
            return toast.error('Informe um departamento', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
        
                progress: undefined,
                theme: "light",
              });
        }


        if(description == undefined || description == ""){
            return toast.error('Informe uma descrição', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
        
                progress: undefined,
                theme: "light",
              });
        }

        if(checkPrimary == false){
            return toast.error('Necessário concordar com os termos!', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
        
                progress: undefined,
                theme: "light",
              });
        }

        const response = await api.post("mail/storage",{
            name:name,
            companyName:companyName,
            mail:mail,
            department:departament,
            description:description
        })

        try {
            
        } catch (error) {
            
        }

        if(response.status == 200){
            return toast.success('Dados enviados com sucesso :)', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });



        }else{
            return toast.error('Opss... algo deu errado! :(', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
        
                progress: undefined,
                theme: "light",
              });
        }
    }

    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: jsonData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,

        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768, // Breakpoint para telas menores, como tablets
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480, // Breakpoint para telas pequenas, como smartphones
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };


    return (
        <>

            <div className={sidebar == false ? 'sidebar_not' : 'sidebar_mobile'}>
                <img src={companyIcon} />

                <div className='container_options_sidebar'>
                    <a onClick={() => setSidebar(false)} href="#"><p>Inicio</p></a>
                    <a onClick={() => setSidebar(false)} href="#service"><p>Serviço</p></a>
                    <a onClick={() => setSidebar(false)} href="#about"><p>Sobre nós </p></a>
                    <a onClick={() => setSidebar(false)} href="#device"><p>Dispositivo </p></a>
                    <a onClick={() => setSidebar(false)} href="#roadmap"><p>Roadmap IOT </p></a>
                    <a onClick={() => setSidebar(false)} href="#contact"><p>Contato </p></a>

                    <a onClick={() => setSidebar(false)} href="https://console.siiota.com/login" target='_blank'><p>Login</p></a>
                </div>

            </div>


            <div class="navbar-area">
                <div class="plamb-responsive-nav">
                    <div class="container">
                        <div class="plamb-responsive-menu">

                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div class="logo">
                                    <a href="#banner-one">
                                        <img src={companyIcon} />
                                    </a>
                                </div>
                                {sidebar == true

                                    ?
                                    <img src={closeIcon} onClick={() => setSidebar(!sidebar)} style={{ width: "40px", height: "40px" }} />
                                    :
                                    <img src={menuIcon} onClick={() => setSidebar(!sidebar)} style={{ width: "50px", height: "50px" }} />

                                }
                            </div>
                        </div>


                    </div>
                </div>
                <div class="plamb-nav">
                    <div class="container">
                        <nav class="navbar navbar-expand-md navbar-light">
                            <a class="navbar-brand" >


                                <img src={companyIcon} />


                            </a>
                            <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                                <ul class="navbar-nav">


                                    <li class="nav-item"> <a href="#banner-one" class="nav-link">
                                        Inicio
                                    </a>
                                    </li>

                                    <li class="nav-item"> <a href="#service" class="nav-link">
                                        Serviços
                                    </a>
                                    </li>


                                    <li class="nav-item"> <a href="#about" class="nav-link">
                                        Sobre nós
                                    </a>
                                    </li>
                                    <li class="nav-item"> <a href="#device" class="nav-link">
                                        Dispositivo
                                    </a>
                                    </li>

                                    <li class="nav-item"> <a href="#roadmap" class="nav-link">
                                        Roadmap IOT
                                    </a>
                                    </li>

                                    <li class="nav-item"> <a href="#contact" class="nav-link">
                                        Contato
                                    </a>
                                    </li>

                                </ul>
                                <div class="other-option"> <a class="btn btn-theme" href="https://console.siiota.com/login"
                                    target="_blank">
                                    Login
                                </a>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>

            <section id="banner-one">
            <ToastContainer/>

                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div class="home-one-banner-content">

                                <h1>Transforme Dados de Máquina em Informações de Negócio!</h1>
                                <h2>Soluções Sob Medida</h2>
                                <p>
                                    Simplifique o gerenciamento de todos os seus equipamentos de forma fácil e intuitiva. Com a
                                    Siiota você tem os recursos necessários para conectar seu Negocio.
                                </p>
                                <div class="banner-one-btn pt30">
                                    <a href="#about" class="btn btn-theme">Saiba Mais</a>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-7 col-sm-12 col-12">
                            <Lottie options={defaultOptions} />
                        </div>
                    </div>


                </div>
            </section>
            <section id="about">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-8 col-md-12 col-sm-12 col-12">
                            <div class="section-title-center text-center pb30">
                                <h2>Sobre Nós</h2>
                                <p class="textPrimary_about">
                                    Sua parceira em projetos de IoT (Internet das Coisas)<br /> e Conectividade Industrial.
                                </p>

                                <p class="textSecondary_about">
                                    Somos especializados em soluções personalizadas para coleta, armazenamento e apresentação de
                                    dados de equipamentos industriais.
                                    Oferecemos suporte em todas as fases do projeto, desde o desenvolvimento até a manutenção e
                                    sustentação.

                                </p>
                                <div class="other-option"> <a class="btn btn-theme" href="#">
                                    Saiba Mais
                                </a>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </section>


            <section id="service">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-10 col-md-12 col-sm-12 col-12">
                            <div class="section-title-center text-center pb30">
                                <h2>O QUE OFERECEMOS?</h2>
                                <p class="textSecondaryServices">SERVIÇOS</p>
                                <Slider className="custom-slider-container"  {...settings}>


                                    <img src="./assets/img/carrousel/Group 37.jpg" />
                                    <img src="./assets/img/carrousel/Group 29.jpg" />

                                </Slider>
                            </div>


                        </div>
                    </div>

                </div>
            </section>


            <div style={{ height: "50px" }}></div>

            <section id="device">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-10 col-md-12 col-sm-12 col-12">
                            <div class="section-title-center text-center pb30">
                                <h2>CONHEÇA NOSSO DISPOSITIVO! </h2>
                                <p class="textSecondaryDevice">Versatilidade, Segurança e Ampla Conectidade </p>

                                <Slider  {...settings}>
                                    <img src="./assets/img/carrousel/Group 38.jpg" />
                                    <img src="./assets/img/carrousel/Group 39.jpg" />

                                </Slider>
                            </div>


                        </div>
                    </div>

                </div>
            </section>

            <div style={{ height: "50px" }}></div>

            <section id="roadmap">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="section-title-center text-center pb30">
                                <h2>Como apoiamos você neste <br />processo? </h2>

                                <p class="textSecondary_section-center">Oferecemos uma Consultoria Especializada para tornar
                                    a<br />implementação de IoT Simples e
                                    Eficiênte. </p>

                                <div class="row_roadmap ">
                                    <p>Cuidamos de todas as etapas do processo.
                                        Com a Siiota, você deixa de se preocupar com desenvolvimento, códigos complexos,
                                        licenciamento de softwares e hardware.
                                        Facilitamos o caminho para que você possa focar no que realmente importa!</p>
                                    <img src="./assets/img/jpg/Group 23 (1).jpg" />

                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </section>

            <section id="service" style={{background:"white"}}>
                <div class="container-sm" id="contact">
                    <div >
                        <div class="section-title-center text-center pb30">
                            <h2>Entre em contato conosco</h2>
                            <p class="textSecondary_contact">Retornaremos o contato o mais breve possivel!</p>

                            <div class="row_contact">

                                <img src={contactIcon} className='contact_icon' />

                                <div class="row_inputs">

                                    <div class="row_input_container">
                                        <div class="container_input" >
                                            <label>Nome Completo</label>
                                            <input value={name} onChange={(e) => setName(e.target.value)} class="input_contact" type="text" />



                                        </div>


                                        <div class="container_input">
                                            <label>Nome empresa</label>
                                            <input value={companyName} onChange={(e) => setCompanyName(e.target.value)} class="input_contact" type="text" />
                                        </div>

                                    </div>
                                    <div class="row_input_container">

                                        <div class="container_input">
                                            <label>Email</label>
                                            <input value={mail} onChange={(e) => setMail(e.target.value)} class="input_contact" type="text" />
                                        </div>


                                        <div class="container_input">
                                            <label>Departamento</label>
                                            <input value={departament} onChange={(e) => setDepartament(e.target.value)} class="input_contact" type="text" />
                                        </div>
                                    </div>

                                    <div class="row_input_container">
                                        <div class="space"></div>
                                        <div class="container_desc">
                                            <label>Descrição detalhada</label>
                                            <textarea value={description} onChange={(e) => setDescription(e.target.value)} aria-expanded="false" class="textArea"></textarea>
                                        </div>
                                    </div>

                                    <div style={{ height: "20px" }}></div>

                                    <div class="row_checkbox">
                                        <input type="checkbox" onChange={(e) => setCheckPrimary(!checkPrimary)} id="check1" name="check1" />
                                        <label for="check1">Concordo em armazenar meus dados.</label>
                                    </div>

                                    <div class="row_checkbox">
                                        <input type="checkbox"  onChange={(e) => setCheckSecondary(!checkSecondary)} id="check2" name="check2" />
                                        <label for="check2">Concordo em receber comunicações</label>
                                    </div>

                                    <button class="button_contact" onClick={() => sendMail()}>Enviar</button>
                                </div>


                                <div className='containerInputMobile'>
                                    <InputMobile value={name} onChange={(e) => setName(e.target.value)}  name="Nome Completo" />
                                    <InputMobile value={companyName} onChange={(e) => setCompanyName(e.target.value)}name="Nome Empresa" />
                                    <InputMobile value={mail} onChange={(e) => setMail(e.target.value)}name="Email" />
                                    <InputMobile value={departament} onChange={(e) => setDepartament(e.target.value)} name="Departamento" />
                                    <TextArea    value={description} onChange={(e) => setDescription(e.target.value)} name="Descrição detalhada" />

                                    <CheckBox />

                                    <button class="button_form" onClick={() => sendMail()}>Enviar</button>


                                </div>

                            </div>


                        </div>



                    </div>
                </div>
            </section>

            <footer id="footer" class="py100">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div class="footer-about-area">
                                <a href="#"><img src="assets/img/common/cloud 1.png" alt="img" /></a>
                                <p class="pt30">
                                    Através da Internet das Coisas (IoT), ajudamos empresas de todos os tamanhos a coletar dados
                                    valiosos em tempo real e transformá-los em insights poderosos para tomada de decisões
                                    estratégicas.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-6">
                            <div class="footer-list-wedget pl20 single-item-mt-3 responsive-mt-60">
                                <div class="fooote-heading">
                                    <h5>Links Úteis</h5>
                                </div>
                                <div class="footer-list pt40">
                                    <ul>
                                        <li onClick={() => scrollToTop()}><a>Home </a></li>
                                        <li><a href="#service"> Serviços</a></li>
                                        <li><a href="#about"> Sobre</a></li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-6">
                            <div class="footer-list-wedget pl20 single-item-mt-3 responsive-mt-60">
                                <div class="fooote-heading">
                                    <h5>SERVIÇOS</h5>
                                </div>
                                <div class="footer-list pt40">
                                    <ul>
                                        <li><a href="#about">Sobre</a></li>
                                        <li><a href="#service">Serviços</a></li>
                                        <li><Link to="/privacy-policy">Política de Privacidade</Link></li>
                                        <li><Link to="/terms-of-service">Termos de Serviço</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div class="footer-list-wedget pl20 responsive-mt-60">
                                <div class="fooote-heading">
                                    <h5>INFORMAÇÕES DE CONTATO</h5>
                                </div>
                                <div class="footer-contact-area footer-list pt40">
                                    <ul>
                                        <li>
                                            <i class="icofont-location-pin"></i><a href="https://www.google.com/maps/search/?api=1&query=Avenida+Conde+Francisco+Matarazzo+-+Bairro+Fundação+-+São+Caetano+do+Sul/SP" target="_blank"> Avenida Conde Francisco Matarazzo - Bairro
                                            Fundação - São Caetano do Sul/SP</a>
                                        </li>
                                        <li>
                                            <i class="icofont-phone"></i><a href="tel:11967903213">+55 (11) 96790-3213</a>
                                        </li>
                                        <li>
                                            <i class="icofont-email"></i><a href="mailto:support@siiota.com">suporte@siiota.com</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom-img">

                </div>
            </footer>

            <div class="copy-right">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div class="copy-text">
                                <p>Siiota © 2023. All Rights Reserved</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div class="copy-icon text-lg-right">
                                <ul>
                                    <li><a href="#!"><i class="fab fa-facebook-f icon"></i></a></li>
                                    <li><a href="#!"><i class="fab fa-twitter icon"></i></a></li>
                                    <li><a href="#!"><i class="fab fa-linkedin-in icon"></i></a></li>
                                    <li><a href="#!"><i class="fab fa-pinterest-p icon"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="go-top" onClick={() => scrollToTop()}>
                <i class="fas fa-chevron-up"></i>
                <i class="icofont-long-arrow-up"></i>
            </div>

        </>

    )
}

export default Landing